export const SECTIONS = [
    { name: "Grammar", apiSection: "grammar" },
    { name: "Vocabulary", apiSection: "vocabulary" },
    { name: "Reading", apiSection: "reading" },
  ];
  
  export const LEVELS = ["N1", "N2", "N3", "N4", "N5"];
  
  // Ensure API_URL always has protocol
const rawApiUrl = process.env.REACT_APP_API_URL || 'https://mina-back.onrender.com';
export const API_URL = rawApiUrl.startsWith('http') ? rawApiUrl : 
  rawApiUrl.includes('localhost') ? `http://${rawApiUrl}` : `https://${rawApiUrl}`;
  export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;